<template>
  <v-container fluid class="pa-5 pb-16 elevation-1">
    <!-- HEADER -->
    <v-sheet
      class="pa-4 w-100 app-header"
      color="#194c9b"
      elevation="2"
      rounded
    >
      <h1 class="text-h4 font-weight-bold d-flex align-center">
        <div class="header-content">
          <v-btn icon color="blue">
            <v-icon>mdi-account-convert-outline</v-icon>
          </v-btn>
          <span class="header-title">{{ $t("titulo_adm_usuario") }}</span>
        </div>
      </h1>
    </v-sheet>

    <!-- CONTENIDO -->
    <v-card>
      <!-- FILTROS -->
      <v-card class="filters cool-card" variant="flat">
        <div class="filter-group">
          <label>{{ $t("buscar") }}</label>
          <v-text-field
            v-model.trim="search"
            :placeholder="$t('input_buscar_usuario')"
            variant="outlined"
            density="comfortable"
            hide-details
            clearable
            prepend-inner-icon="mdi-magnify"
          />
        </div>

        <div class="checkbox-wrapper">
          <v-checkbox
            v-model="showInactiveOnly"
            :label="$t('chek_adm_usuario')"
            color="primary"
            hide-details
            density="comfortable"
          />
        </div>
      </v-card>

      <!-- EMPTY: sin usuarios -->
      <v-empty-state
        v-if="users.length === 0"
        icon="mdi-account-off-outline"
        :title="$t('no_usuario')"
        :text="$t('no_usuario_msg')"
      />

      <!-- TABLA / RESULTADOS -->
      <template v-else>
        <!-- EMPTY: sin resultados -->
        <v-empty-state
          v-if="filteredUsers.length === 0"
          icon="mdi-magnify"
          :title="$t('no_resultados')"
          :text="$t('no_resultados_msg')"
        >
          <template #actions>
            <v-btn
              variant="tonal"
              color="primary"
              rounded="lg"
              @click="clearFilters"
            >
              {{ $t("filtros") }}
            </v-btn>
          </template>
        </v-empty-state>

        <!-- TABLA -->
        <v-card
          v-else
          rounded="lg"
          variant="outlined"
          class="cool-card table-card"
        >
          <v-table class="pro-table" hover>
            <thead>
              <tr>
                <th class="col-id">ID</th>
                <th class="col-user">{{ $t("nombreuser") }}</th>
                <th class="col-email">{{ $t("correo") }}</th>
                <th class="col-unidad">Unidad Negocio</th>
                <th class="col-rol">Rol</th>
                <th class="col-activo text-center">Activo</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="user in pagedUsers" :key="user.id">
                <td>{{ user.id }}</td>
                <td>{{ user.username }}</td>
                <td>{{ user.email }}</td>
                <td>
                <v-chip
                v-if="user.unidad_nombre"
                    class="ma-1"
                    color=blue
                    variant="tonal"
                    
                  >
                    {{ user.unidad_nombre }}
                  </v-chip>
                  </td>
                <td>
                  <v-chip
                    v-if="user.role"
                    class="ma-1"
                    :color="roleBadgeClass(user.role)"
                    variant="tonal"
                    @click="openDialog(user)"
                  >
                    {{ user.role }}
                  </v-chip>

                  <v-chip
                    v-else
                    class="ma-1"
                    color="grey"
                    variant="tonal"
                    @click="openDialog(user)"
                  >
                    {{ $t("sin_rol") }}
                  </v-chip>
                </td>

                <td class="text-center">
                  <v-switch
                    v-model="user.is_active"
                    color="success"
                    inset
                    hide-details
                    @change="toogle(user)"
                  />
                </td>
              </tr>
            </tbody>
          </v-table>

          <v-divider class="my-4" />

          <!-- FOOTER / PAGINACIÓN -->
          <div
            class="d-flex align-center justify-space-between flex-wrap ga-3 px-4 pb-4 table-footer"
          >
            <div class="d-flex align-center ga-2">
              <span class="text-caption text-medium-emphasis">{{
                $t("paginacion")
              }}</span>

              <v-select
                v-model="itemsPerPage"
                :items="[5, 8, 10, 20]"
                density="compact"
                variant="outlined"
                hide-details
                class="items-select"
                style="max-width: 110px"
              />
            </div>

            <v-pagination
              v-model="page"
              :length="pageCount"
              density="comfortable"
              :total-visible="6"
            />
          </div>
        </v-card>
      </template>
    </v-card>
    <ModalesRoles
      v-model="dialogRole"
      :user="userSetRole"
      @roles-updated="obtainUsers"
    />
  </v-container>
</template>
<script>
import "@/css/Proyectos/StyleTableProyect.css";
import ModalesRoles from "@/components/RolesComponentes/ModalesRoles.vue";
import { getUsers, setActiveUser } from "@/api/usuarios";
import { useSettingsStore } from "@/stores/settings";
import { swal } from "@/utils/swal";

export default {
  name: "AdminRol",
  components: {
    ModalesRoles,
  },
  data() {
    return {
      showInactiveOnly: false,
      dialogRole: false,
      search: "",
      id: null,
      deleteDialog: false,
      itemsPerPage: 5,
      userSetRole: null,
      editDialog: false,
      selectedProject: null,
      users: [],
      page: 1,
      allUsers: [],
      loadingProjects: false,
      unitMap: {},
    };
  },
  async mounted() {
    await this.obtainUsers();
  },
  computed: {
    isDark() {
      const settings = useSettingsStore();
      return settings.theme === "dark";
    },
    pageCount() {
      const total = this.filteredUsers.length;
      const per = Number(this.itemsPerPage) || 8;
      return Math.max(1, Math.ceil(total / per));
    },
    pagedUsers() {
      const per = Number(this.itemsPerPage) || 8;
      const start = (this.page - 1) * per;
      console.log("EEE",this.filteredUsers)
      return this.filteredUsers.slice(start, start + per);
    },
    filteredUsers() {
      const us = (this.search || "").toLowerCase();
      if (!Array.isArray(this.users)) return [];
      let matchesSearch = this.users.filter((u) => {
        return (
          !us ||
          u.username.toLowerCase().includes(us) ||
          u.email.toLowerCase().includes(us)
        );
      });
      if (this.showInactiveOnly) {
        matchesSearch = matchesSearch.filter((u) => !u.is_active);
      }
      return matchesSearch;
    },
  },
  watch: {
    itemsPerPage() {
      this.page = 1;
    },
    search() {
      this.page = 1;
    },
    showInactiveOnly() {
      this.page = 1;
    },
  },
  methods: {
    async toogle(u) {
      const previousValue = u.is_active;
      const newValue = !previousValue;
      const res = await setActiveUser(u.id, u.is_active);
      if (res.message != "Se activo correctamente") {
       await swal({
          icon: "error",
          title: this.$t("error"),
          text: this.$t("user_permission_toggle_error"),
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
        u.is_active = !previousValue;
        return;
      }
      u.is_active = !newValue;
    },
    openDialog(usu) {
      this.userSetRole = usu;
      this.dialogRole = true;
    },
    roleBadgeClass(role) {
      switch (role) {
        case "Admin QA":
          return "primary";
        case "Owner QA":
          return "warning";
        case "Tester QA":
          return "purple";
        case "false":
          return "secundary";
        default:
          return "success";
      }
    },

    clearFilters() {
      Object.assign(this.$data, {
        search: "",
        showInactiveOnly: false,
        page: 1,
      });
    },

    async obtainUsers() {
      try {
        const response = await getUsers();

        if (Array.isArray(response)) {
          this.users = response;
        } else if (Array.isArray(response.users)) {
          this.users = response.users;
        } else {
          this.users = [];
          if (response.detail) alert(response.detail); // mostrar mensaje si hay error de permisos
        }
      } catch (e) {
        this.users = [];
      } finally {
        this.loadingProjects = false;
      }
    },
  },
};
</script>
<style scoped>
.table-footer {
  padding: 12px 16px;
  margin-top: 8px;
}

.items-select {
  width: 110px;
}
</style>
